import React from 'react';

import commonStyles from '../styles.module.css';

function Languages(props) {
    return (
        <div style={{ width: '80%', margin: '0 auto' }}>
            <div className={commonStyles.title}>Languages</div>
        </div>
    )
}

export default Languages;
